import { render, staticRenderFns } from "./DomoEmbedForm.vue?vue&type=template&id=9d1a530a&scoped=true"
import script from "./DomoEmbedForm.vue?vue&type=script&lang=js"
export * from "./DomoEmbedForm.vue?vue&type=script&lang=js"
import style0 from "./DomoEmbedForm.vue?vue&type=style&index=0&id=9d1a530a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1a530a",
  null
  
)

export default component.exports